/*
  Export a JSON Array of Objects into a CSV:
  Props:
    data: Array of Objects with keys from dataHeaders
    dataHeaders: Array of column names matching the key values
    options: Object Options
      fileName: Name of file (default: 'data')
      noValue: Value of empty or non-existent values (default: "No Value")
*/

import React, { Component } from 'react';
import './ExportToCSV.css';
import { t } from 'i18next';

class ExportToCSVComponent extends Component {
  constructor(props) {
    super(props);

    this.button = React.createRef();
  }

  exportToCSV = (items, header, options) => {
    if (this.button.current) {
      // Create CSV file content
      let csv = items.map(row => header.map(fieldName => row[fieldName] || options.noValue).join(','));
      csv.unshift(header.join(','));
      csv = csv.join('\r\n');

      // Create blob with CSV content and trigger download link
      const blob = new Blob(['\ufeff', csv]);

      const downloadLink = document.createElement('a');
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = `${options.fileName}.csv`;
      this.button.current.appendChild(downloadLink);
      downloadLink.click();
      this.button.current.removeChild(downloadLink);
    }
  }

  render() {
    const {
      data: propsData,
      dataHeaders,
      options,
    } = this.props;
    options.noValue = t('tensorAnalytics.exportToCSVComponent.noValueDefault');
    return (
      <div className="button"
        ref={this.button}
      >
        <span role="presentation" onClick={() => this.exportToCSV(propsData || [], dataHeaders || [], options)}>
          {' '}
          {t('tensorAnalytics.exportToCSVComponent.exportToCSVButton')}
          {' '}
        </span>
      </div>
    );
  }
}

export default ExportToCSVComponent;
